import { grpc } from '@improbable-eng/grpc-web';
import { NodeHttpTransport } from '@improbable-eng/grpc-web-node-http-transport';

import { ChatClientImpl, GrpcWebImpl } from '../api/v0/chat';
import { protoMeta } from './token';

function getGrpc(body?: any) {
  return new GrpcWebImpl(body?.grpcHost, {
    transport: NodeHttpTransport(),
    metadata: new grpc.Metadata({ ...protoMeta(body?.token, body?.clientID), ...body }),
  });
}

export const getChatClient = (metaData?: object) => {
  return new ChatClientImpl(getGrpc(metaData));
};
